<template>
     <div class="grid" v-if="getMovil() == null || getParada() == null">
		<div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-2">
			<Message severity="error" class="p-col-12">
				Para poder operar en el sistema debe seleccionar el comedor y parada donde está cumpliendo funciones.
			</Message>
		</div>
	</div>
    <div class="grid" v-if="getMovil() != null && getParada() != null">
		<div class="col-12 md:col-6 xl:col-3">
			<div class="card grid-nogutter widget-overview-box widget-overview-box-1">
				<span class="overview-icon">
					<i class="pi pi-chart-pie"></i>
				</span>
				<span class="overview-title">Reporte diario de entregas</span>
				<div class="grid overview-detail">
					<div class="col-12">
						<div class="overview-subtext">Visualización de las entregas realizadas el día de hoy en el comedor seleccionado en el sistema, así como la desagregación de las entregas efectuadas por el usuario autenticado en el sistema. 
                            Se recomienda siempre recargar datos para visualizar información actualizada.</div>
					</div>
				</div>
			</div>
		</div>
            
        <div class="grid p-mt-5">
			<div class="col-12">
				<div class="card">
                    <Message class="p-col-12">
                        Usted está operando en:<br>
                        <i class="pi pi-map"/> {{getMovilName()}}<br>
                        <i class="pi pi-map-marker"/> <i>{{getParadaName()}}</i>
                    </Message>
                    <Toolbar>
                        <template v-slot:left>
                            
                        </template>

                        <template v-slot:right>
                            <Button label="Recargar Datos" @click="reloadData()" icon="pi pi-refresh" iconPos="left" :loading="loading"/>
                        </template>
                    </Toolbar>
                    <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-2">
                        <div class="p-field p-col-12 p-md-6">
                            <Fieldset class="p-shadow-2">
                                <template #legend>
                                    <div>
                                        <span class="pi pi-truck p-mr-2"></span>
                                        <span style="font-weight: bold;font-size:1.125rem;color: #0f89ec;">Entregas en el comedor</span>
                                    </div>
                                </template>
                                <div class="p-grid p-mt-3">
                                    <div class="p-col-12 p-md-6">
                                        Total de viandas entregadas:
                                    </div>
                                    <div class="p-col-12 p-md-6">
                                        {{totalM}}
                                    </div>
                                </div>
                                <div class="p-grid p-mt-3">
                                    <div class="p-col-12 p-md-6">
                                        Por QR / Código:
                                    </div>
                                    <div class="p-col-12 p-md-6">
                                        {{QRM}}
                                    </div>
                                </div>
                                <div class="p-grid p-mt-3">
                                    <div class="p-col-12 p-md-6">
                                        Por excepción:
                                    </div>
                                    <div class="p-col-12 p-md-6">
                                        {{EXM}}
                                    </div>
                                </div>
                            </Fieldset>
                        </div>
                        <div class="p-field p-col-12 p-md-6">
                            <Fieldset class="p-shadow-2">
                                <template #legend>
                                    <div>
                                        <span class="pi pi-user p-mr-2"></span>
                                        <span style="font-weight: bold;font-size:1.125rem;color: #0f89ec;">Entregas por el usuario</span>
                                    </div>
                                </template>
                                <div class="p-grid p-mt-3">
                                    <div class="p-col-12 p-md-6">
                                        Total de viandas entregadas:
                                    </div>
                                    <div class="p-col-12 p-md-6">
                                        {{totalU}}
                                    </div>
                                </div>
                                <div class="p-grid p-mt-3">
                                    <div class="p-col-12 p-md-6">
                                        Por QR / Código:
                                    </div>
                                    <div class="p-col-12 p-md-6">
                                        {{QRU}}
                                    </div>
                                </div>
                                <div class="p-grid p-mt-3">
                                    <div class="p-col-12 p-md-6">
                                        Por excepción:
                                    </div>
                                    <div class="p-col-12 p-md-6">
                                        {{EXU}}
                                    </div>
                                </div>
                            </Fieldset>
                        </div>        
                    </div>

                <TabView>
                    <TabPanel header="QR o código">
                        <div class="p-field p-col-12 p-md-12">
                            <DataTable :value="entregadasQR" responsiveLayout="scroll" :filters="filters" :loading="loadingtable1" class="mt-3 p-shadow-2"
                            :paginator="true" :rows="10" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            :rowsPerPageOptions="[10,20,50]" currentPageReportTemplate="Mostrando {first} al {last} de {totalRecords}"
                            >
                                <template #header>
                                    <div class="table-header">
                                        <h6 class="p-mb-2">QR/código entregadas hoy por el usuario</h6>
                                        <span class="p-input-icon-left p-mb-2">
                                            <i class="pi pi-search" />
                                            <InputText v-model="filters['global'].value" placeholder="Criterio de búsqueda" style="width: 100%"/>
                                        </span>
                                    </div>
                                </template>
                                <template #empty>
                                    No hay información relacionada con entregas del día de hoy.
                                </template>
                                <template #loading>
                                    Cargando entregas realizadas hoy. Espere por favor.
                                </template>
                                <Column field="ci" header="CI"></Column>
                                <Column field="qr" header="Código"></Column>
                                <Column field="parada" header="Parada"></Column>
                                <Column field="hora" header="Hora" sortable="true"></Column>
                                <Column field="cantidad" header="Cantidad"></Column>
                            </DataTable>
                        </div>
                    </TabPanel>
                    <TabPanel header="Excepciones">
                        <div class="p-field p-col-12 p-md-12">
                            <DataTable :value="entregadasEX" responsiveLayout="scroll" :filters="filters2" :loading="loadingtable2" class="mt-3 p-shadow-2"
                            :paginator="true" :rows="10" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            :rowsPerPageOptions="[10,20,50]" currentPageReportTemplate="Mostrando {first} al {last} de {totalRecords}"
                            >
                                <template #header>
                                    <div class="table-header">
                                        <h6 class="p-mb-2">Excepciones entregadas hoy por el usuario</h6>
                                        <span class="p-input-icon-left p-mb-2">
                                            <i class="pi pi-search" />
                                            <InputText v-model="filters2['global'].value" placeholder="Criterio de búsqueda" style="width: 100%"/>
                                        </span>
                                    </div>
                                </template>
                                <template #empty>
                                    No hay información relacionada a entregas del día de hoy.
                                </template>
                                <template #loading>
                                    Cargando entregas realizadas hoy. Espere por favor.
                                </template>
                                <Column field="motivo" header="Motivo" sortable="true"></Column>
                                <Column field="parada" header="Parada"></Column>
                                <Column field="hora" header="Hora" sortable="true"></Column>
                                <Column field="cantidad" header="Cantidad"></Column>
                            </DataTable>
                        </div>
                    </TabPanel>
                    <TabPanel header="Dietas">
                        <div class="p-field p-col-12 p-md-12">
                            <DataTable :value="viandasdietas" responsiveLayout="scroll" :filters="filters3" :loading="loadingtable3" class="mt-3 p-shadow-2"
                            :paginator="true" :rows="10" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            :rowsPerPageOptions="[10,20,50]" currentPageReportTemplate="Mostrando {first} al {last} de {totalRecords}"
                            >
                                <template #header>
                                    <div class="table-header">
                                        <h6 class="p-mb-2">Viandas entregadas hoy en el comedor por tipo de dieta</h6>
                                        <span class="p-input-icon-left p-mb-2">
                                            <i class="pi pi-search" />
                                            <InputText v-model="filters3['global'].value" placeholder="Criterio de búsqueda" style="width: 100%"/>
                                        </span>
                                    </div>
                                </template>
                                <template #empty>
                                    No hay información relacionada con entregas del día de hoy.
                                </template>
                                <template #loading>
                                    Cargando entregas realizadas hoy. Espere por favor.
                                </template>
                                <Column field="dieta" header="Tipo de dieta"></Column>
                                <Column field="cantidad" header="Cantidad"></Column>
                            </DataTable>
                        </div>
                    </TabPanel>
                </TabView>
                </div>
            </div>
        </div>   
    </div>
    

	<Dialog header="Aguarde..." v-model:visible="wait" :style="{width: '150px'}" :modal="true" :position="left">
		<div align="center">
			<ProgressSpinner style="width:50px;height:50px" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"/>
		</div>
	</Dialog>
	
</template>

<script>
import SmartService from '../service/SmartService';
import {FilterMatchMode,FilterOperator} from 'primevue/api';
export default {
	data() {
		return {
			wait: false,
            loading: false,
            loadingtable1: false,
            loadingtable2: false,
            loadingtable3: false,
            totalM: null,
            QRM: null,
            EXM: null,
            totalU: null,
            QRU: null,
            EXU: null,
            filters: {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'CI': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.EQUALS}]},
                'codigo': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]},
                'parada': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]},
                'hora': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.EQUALS}]},
                'cantidad': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.EQUALS}]},
            },
            filters2: {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'motivo': {operator: FilterOperator.OR, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]},
                'parada': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]},
                'hora': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.EQUALS}]},
                'cantidad': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.EQUALS}]},
            },
            filters3: {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'dieta': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]},
                'cantidad': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.EQUALS}]},
            },
            entregadasEX: null,
            entregadasQR: null,
            viandasdietas: null,
		}
	},	
	smartService: null,
	created() {
		this.smartService = new SmartService();
	},
	mounted() {
        this.reloadData();
	},
	methods: {
        getMovil(){
            return localStorage.movil_id;
        },

        getParada(){
            return localStorage.parada_id;
        },

        getIdTec(){
            return localStorage.tec_id;
        },

        getMovilName(){
            return localStorage.movil_name;
        },

        getParadaName(){
            return localStorage.parada_name;
        },

        getUsuario(){
            return localStorage.nombre;
        },

        async cargarDatos(){
            this.smartService.cantidadesHoy(Number(this.getMovil()), Number(this.getIdTec())).then(data => {        	
                this.loading = true;
                this.QRU = data.cantRetiroTecnico;
                this.QRM = data.cantRetiroComedor;
                this.EXU = data.cantRetiroExcpTecnico;
                this.EXM = data.cantRetiroExcpComedor;
                this.totalM = data.totalComedor;
                this.totalU = data.totalTecnico;
                this.loading = false;
            });
        },

        async cargarEntregasC(){
            this.loadingtable1 = true;
            this.loading = true;
            this.entregadasQR = [];
            this.smartService.obtenerCodigoHoy(Number(this.getMovil()), Number(this.getIdTec())).then(data => {
                for (let r of data){
                    let aux = {ci:r.qr.persona.documento, qr: r.qr.codigo, parada: r.parada.parNombre, hora: r.horaRetiro, cantidad: r.cantidadViandas};  
                    this.entregadasQR.push(aux);  
                }
                this.loadingtable1 = false;
                this.loading = false;
            });
        },

        async cargarEntregasExc(){
            this.loadingtable2 = true;
            this.loading = true;
            this.entregadasEX = [];
            this.smartService.obtenerExcHoy(Number(this.getMovil()), Number(this.getIdTec())).then(data => {
                for (let r of data){
                    let aux = {motivo:r.motivo.nombre, parada: r.parada.parNombre, hora: r.horaRetiro, cantidad: r.cantidadViandas};  
                    this.entregadasEX.push(aux);  
                }
                this.loadingtable2 = false;
                this.loading = false;
            });
        },

        async cargarDistDietas(){
            this.loadingtable3 = true;
            this.loading = true;
            this.viandasdietas = [];
            this.smartService.obtenerDietasHoy(Number(this.getMovil())).then(data => {
                for (let r of data){
                    let aux = {dieta:r.tipoDieta, cantidad: r.cantidad};  
                    this.viandasdietas.push(aux);  
                }
                this.loadingtable3 = false;
                this.loading = false;
            });
        },

        reloadData(){
            this.cargarDatos();
            this.cargarEntregasC();
            this.cargarEntregasExc();
            this.cargarDistDietas();
        }

	},
}
</script>

<style scoped lang="scss">
    .table-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
	.overview-detail {
        text-align: left;
        margin-top: 2rem;

        .p-col-6 {
            padding: .5rem;
        }
    }
</style>